
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const Get_M_Ward_Wise_PillerNo_SelectTableDataAPI = createAsyncThunk("Get_M_Ward_Wise_PillerNo_SelectTableData", async ({ data }) => {
    const {
        M_FinancialYearID,
        M_MonthID,
        M_WardID,
        M_ELEC_PillerID,
        M_Ward_Wise_VendorID,
        UserID,
        settableData,
        handleData,
        token,
        From,
        To
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_Ward_Wise_PillerNo_Select?M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ELEC_PillerID=${M_ELEC_PillerID}&M_WardID=${M_WardID}&M_Ward_Wise_VendorID=${M_Ward_Wise_VendorID}&M_UserID=${UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result?.data) {
                settableData(result.data)
                handleData && handleData()
                return result.data
            } else {
                settableData([])
                handleData && handleData()
                return result
            }
        })
})

const Get_M_Ward_Wise_PillerNo_SelectTableDataSlice = createSlice({
    name: "Get_M_Ward_Wise_PillerNo_SelectTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_M_Ward_Wise_PillerNo_SelectTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_M_Ward_Wise_PillerNo_SelectTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Get_M_Ward_Wise_PillerNo_SelectTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_M_Ward_Wise_PillerNo_SelectTableDataReducer = Get_M_Ward_Wise_PillerNo_SelectTableDataSlice.reducer




// Get Table Data
export const Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI = createAsyncThunk("Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableData", async ({ data }) => {
    const {
        T_ELE_Excel_CurrentRating_TempdataID,
        M_FinancialYearID,
        M_MonthID,
        M_ELEC_WorkID,
        M_Ward_Wise_VendorID,
        M_WardID,
        M_ELEC_PillerID,
        UserID,
        token,
        From,
        To
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_T_ELE_Excel_CurrentRating_Tempdata_Select?T_ELE_Excel_CurrentRating_TempdataID=${T_ELE_Excel_CurrentRating_TempdataID}&M_FinancialYearID=${M_FinancialYearID}&M_MonthID=${M_MonthID}&M_ELEC_WorkID=${M_ELEC_WorkID}&M_WardID=${M_WardID}&M_Ward_Wise_VendorID=${M_Ward_Wise_VendorID}&M_ELEC_PillerID=${M_ELEC_PillerID}&M_UserID=${UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataSlice = createSlice({
    name: "Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataReducer = Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataSlice.reducer
